import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { StoryComponent } from './story/story.component';
import { WorkspaceComponent } from './workspace/workspace.component';
import { CreateApikeyComponent } from './create-apikey/create-apikey.component';
import { ViewWorkspaceComponent } from './view-workspace/view-workspace.component';
import { UsersComponent } from './users/users.component';
import { AddUserComponent } from './add-user/add-user.component';
import { MemoriesComponent } from './memories/memories.component';
import { InteractionsComponent } from './interactions/interactions.component';
import { RemindersComponent } from './reminders/reminders.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { ApiAuditsComponent } from './api-audits/api-audits.component';
import { ReadMeComponent } from './read-me/read-me.component';
import { QuickstartComponent } from './quickstart/quickstart.component';
import { UsageComponent } from './usage/usage.component';
import { LabComponent } from './lab/lab.component';
import { PaymentsComponent } from './payments/payments.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { AuthorizeGuard } from './app.auth-gaurd';
import { PlanGuard } from './services/plan-gate.guard';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { ChatComponent } from './chat/chat.component';
import { DevelopersComponent } from './developer/developer.component';
import { RecipeComponent } from './recipe/recipe.component';
import { ReceiptComponent } from './receipt/receipt.component';
import { NutritionComponent } from './nutrition/nutrition.component';
import { McpGuideComponent } from './mcp-guide/mcp-guide.component';
import { RecipesComponent } from './recipes/recipes.component';
import { SharedWorkspacesComponent } from './shared-workspaces/shared-workspaces.component';
import { SharedWorkspaceDetailComponent } from './shared-workspace-detail/shared-workspace-detail.component';
import { AcceptInviteComponent } from './accept-invite/accept-invite.component';
import { SessionGuard } from './services/session.guard';

const routes: Routes = [
  // Story page is now the landing page
  { path: '', component: StoryComponent },
  { path: 'story', component: StoryComponent },

  // Login page
  { path: 'login', component: LoginComponent },

  { path: 'developers', component: DevelopersComponent },
  { path: 'recipes', component: RecipesComponent },
  { path: 'mcp-guide', component: McpGuideComponent },

  // App routes
  { path: 'workspace', component: WorkspaceComponent, canActivate: [PlanGuard] },
  { path: 'read-me', component: ReadMeComponent, canActivate: [PlanGuard] },
  { path: 'quickstart', component: QuickstartComponent, canActivate: [PlanGuard] },
  { path: 'users', component: UsersComponent, canActivate: [PlanGuard] },
  { path: 'user-dashboard/:userkey', component: UserDashboardComponent, canActivate: [PlanGuard] },
  { path: 'chat/:userkey', component: ChatComponent, canActivate: [PlanGuard] },
  { path: 'interactions', component: InteractionsComponent, canActivate: [PlanGuard] },
  { path: 'reminders', component: RemindersComponent, canActivate: [PlanGuard] },
  { path: 'reminders/:key', component: RemindersComponent, canActivate: [PlanGuard] },
  { path: 'memories', component: MemoriesComponent, canActivate: [PlanGuard] },
  { path: 'memories/:key', component: MemoriesComponent, canActivate: [PlanGuard] },
  { path: 'recipe', component: RecipeComponent, canActivate: [PlanGuard] },
  { path: 'recipe/:key', component: RecipeComponent, canActivate: [PlanGuard] },
  { path: 'receipt', component: ReceiptComponent, canActivate: [PlanGuard] },
  { path: 'receipt/:key', component: ReceiptComponent, canActivate: [PlanGuard] },
  { path: 'nutrition', component: NutritionComponent, canActivate: [PlanGuard] },
  { path: 'nutrition/:key', component: NutritionComponent, canActivate: [PlanGuard] },
  { path: 'create-apikey', component: CreateApikeyComponent, canActivate: [PlanGuard] },
  { path: 'add-user', component: AddUserComponent, canActivate: [PlanGuard] },
  { path: 'usage', component: UsageComponent, canActivate: [PlanGuard] },
  { path: 'lab', component: LabComponent, canActivate: [PlanGuard] },
  { path: 'payments', component: PaymentsComponent },
  { path: 'terms/:blk', component: TermsOfUseComponent },
  { path: 'privacy-policy/:blk', component: PrivacyPolicyComponent },
  { path: 'subscription', component: SubscriptionComponent },
  { path: 'view-workspace/:id/:name/:key', component: ViewWorkspaceComponent, canActivate: [PlanGuard] },
  // Shared workspaces. SessionGuard, not AuthorizeGuard (which reads a cookie
  // this app never sets) and not PlanGuard (which gates on an allowance that
  // is not the reader's) - see services/session.guard.ts.
  { path: 'shared-workspaces', component: SharedWorkspacesComponent, canActivate: [SessionGuard] },
  { path: 'shared-workspace/:id', component: SharedWorkspaceDetailComponent, canActivate: [SessionGuard] },
  // Where the emailed invitation lands. Unguarded on purpose - it handles the
  // signed-out case itself rather than bouncing and losing the token.
  { path: 'invite', component: AcceptInviteComponent },
  { path: 'api-audits', component: ApiAuditsComponent, canActivate: [PlanGuard] },

  // Fallback - redirect to story page instead of login
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }